import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row row-cols-1 row-cols-sm-2 row-cols-lg-2 row-cols-xl-4" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "align-self-end" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_14 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
      class: "mt-2",
      ref: "searchCriteriaFormRef",
      model: _ctx.searchCriteria,
      rules: _ctx.searchCriteriaFormRules,
      "label-position": 'right',
      "label-width": 'auto'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('form.label.project_code')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.pjcode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.pjcode) = $event)),
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              tem: "",
              label: _ctx.t('form.label.WFS')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.searchCriteria.manufMethodIds,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCriteria.manufMethodIds) = $event)),
                  class: "w-100",
                  multiple: "",
                  loading: _ctx.isManufMethodListLoading,
                  placeholder: _ctx.t('placeholder.select'),
                  onVisibleChange: _ctx.onManufMethodListShown
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allManufMethodList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.methodName,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading", "placeholder", "onVisibleChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('form.label.team'),
              prop: "teamNum"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.teamNum,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchCriteria.teamNum) = $event)),
                  clearable: "",
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              tem: "",
              label: _ctx.t('form.label.applicant')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.creator,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchCriteria.creator) = $event)),
                  clearable: "",
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('form.label.Kaizen_PN')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.pn,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchCriteria.pn) = $event)),
                  clearable: "",
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('form.label.startDate'),
              prop: "startDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  style: {"width":"100%"},
                  placeholder: _ctx.t('placeholder.date'),
                  "value-format": "YYYY-MM-DD",
                  type: "month",
                  modelValue: _ctx.searchCriteria.startDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchCriteria.startDate) = $event)),
                  clearable: "",
                  name: "startDate"
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              tem: "",
              label: _ctx.t('form.label.endDate'),
              prop: "endDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  style: {"width":"100%"},
                  placeholder: _ctx.t('placeholder.date'),
                  "value-format": "YYYY-MM-DD",
                  type: "month",
                  modelValue: _ctx.searchCriteria.endDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchCriteria.endDate) = $event)),
                  clearable: "",
                  name: "endDate"
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_button, {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onClearSearchKaizenClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSearchKaizenClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_popover, {
          placement: "bottom",
          onHide: _ctx.onColDisplayCtrlPanelHidded,
          trigger: "click",
          Title: _ctx.t('column')
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { link: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Operation)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[0],
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("PJCode")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[1],
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("kaizenCode")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[2],
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen_PN")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[3],
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.colDisplayCtrl[3]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("team")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[4],
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.colDisplayCtrl[4]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Job_Number")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[5],
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.colDisplayCtrl[5]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("work_remark")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[6],
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.colDisplayCtrl[6]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("WFS")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[7],
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.colDisplayCtrl[7]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen_Plan")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[8],
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.colDisplayCtrl[8]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[9],
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.colDisplayCtrl[9]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen_Content")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[10],
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.colDisplayCtrl[10]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("implement_day")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[11],
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.colDisplayCtrl[11]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("hyperlink")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[12],
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.colDisplayCtrl[12]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen_Before_Work_Hours")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[13],
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.colDisplayCtrl[13]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Kaizen_After_Work_Hours")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[14],
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.colDisplayCtrl[14]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("creator")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[15],
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.colDisplayCtrl[15]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("createDate")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["onHide", "Title"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "kaizenItemTableRef",
        class: "w-100",
        type: "selection",
        "max-height": 450,
        data: _ctx.displayKaizenList,
        stripe: true,
        "highlight-current-row": "",
        onCurrentChange: _ctx.onKaizenItemSelectChanged,
        onSortChange: _ctx.onSortChanged
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: "70",
            prop: "radio",
            fixed: "left",
            align: "center",
            label: _ctx.t('select')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_radio, {
                modelValue: _ctx.tableRadio,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.tableRadio) = $event)),
                label: scope.row.id
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["modelValue", "label"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.colDisplayCtrl[0])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                "min-width": "140",
                sortable: "custom",
                prop: "projectCode",
                label: _ctx.t('PJCode')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[1])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                "min-width": "160",
                sortable: "custom",
                prop: "kaizenCode",
                label: _ctx.t('kaizenCode')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[2])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                "min-width": "120",
                sortable: "custom",
                prop: "pn",
                label: _ctx.t('Kaizen_PN')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[3])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                "min-width": "120",
                sortable: "custom",
                prop: "teamNum",
                label: _ctx.t('team')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[4])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                "min-width": "120",
                sortable: "custom",
                prop: "workNum",
                label: _ctx.t('Job_Number')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[5])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                "min-width": "120",
                sortable: "custom",
                prop: "workRemark",
                label: _ctx.t('work_remark')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[6])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                "min-width": "120",
                sortable: "custom",
                prop: "manufMethodName",
                label: _ctx.t('WFS')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[7])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 7,
                "min-width": "120",
                sortable: "custom",
                prop: "impPlan",
                label: _ctx.t('Kaizen_Plan')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[8])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 8,
                "min-width": "120",
                sortable: "custom",
                prop: "impMethod",
                label: _ctx.t('Kaizen')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[9])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 9,
                "min-width": "120",
                sortable: "custom",
                prop: "impMethodDetail",
                label: _ctx.t('Kaizen_Content')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[10])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 10,
                "min-width": "140",
                sortable: "custom",
                prop: "implementDay",
                label: _ctx.t('implement_day')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[11])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 11,
                "min-width": "120",
                sortable: "custom",
                prop: "hyperlink",
                label: _ctx.t('hyperlink')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[12])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 12,
                "min-width": "120",
                sortable: "custom",
                prop: "procTimeBeforeImp",
                label: _ctx.t('Kaizen_Before_Work_Hours')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[13])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 13,
                "min-width": "120",
                sortable: "custom",
                prop: "procTimeAfterImp",
                label: _ctx.t('Kaizen_After_Work_Hours')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[14])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 14,
                "min-width": "120",
                sortable: "custom",
                prop: "creatorDisplayName",
                label: _ctx.t('creator')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[15])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 15,
                "min-width": "220",
                sortable: "custom",
                prop: "createTime",
                label: _ctx.t('createDate')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "onCurrentChange", "onSortChange"])), [
        [
          _directive_loading,
          _ctx.isTableLoading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_el_row, {
      justify: "end",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_pagination, {
                currentPage: _ctx.searchCriteria.page,
                "onUpdate:currentPage": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.searchCriteria.page) = $event)),
                "page-size": _ctx.searchCriteria.pageSize,
                "onUpdate:page-size": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.searchCriteria.pageSize) = $event)),
                "pager-count": _ctx.paginatorSetup.pagerCount,
                layout: _ctx.paginatorSetup.layout,
                small: _ctx.paginatorSetup.small,
                "page-sizes": [10, 50, 100],
                total: _ctx.filteredTotal,
                onSizeChange: _ctx.onPagesizeChanged,
                onCurrentChange: _ctx.onCurrentPageChanged,
                justify: "end"
              }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}